import { render } from "./SingleComment.vue?vue&type=template&id=7281e48c&scoped=true&ts=true"
import script from "./SingleComment.vue?vue&type=script&lang=ts"
export * from "./SingleComment.vue?vue&type=script&lang=ts"

import "./SingleComment.vue?vue&type=style&index=0&id=7281e48c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7281e48c"]])

export default __exports__